import Grid from '@mui/material/Grid'
import Tooltip from '@mui/material/Tooltip'
import { ProgressBar } from 'pages/CMS/components/SocialWall/components/ProgressBar'
import { WidgetValue } from 'utils/api/Values/fetchWidgetValues'
import { useGetObjectTranslation } from 'utils/useGetObjectTranslation'

type Props = {
  value: WidgetValue
}

export const ValueRow = ({ value }: Props) => {
  const name = useGetObjectTranslation(value.translation, 'name')
  return (
    <Grid key={value.id} container alignItems="center" rowGap={1} wrap="nowrap" data-cy={`widget-value-${value.id}`}>
      <Grid item xs={4} sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
        <Tooltip title={name} placement="left" data-cy="value-tooltip">
          <span data-cy="value-name">{name}</span>
        </Tooltip>
      </Grid>
      <Grid item gap={1} container alignItems="center" xs wrap="nowrap">
        <Grid sx={{ width: '5ch' }} textAlign="right" data-cy="value-percentage">
          {value.percentage}%
        </Grid>
        <Grid item xs>
          <ProgressBar progress={value.percentage} animated />
        </Grid>
      </Grid>
    </Grid>
  )
}
